<div class="tape"></div>
<div class="score">{{match.teams.optional.score}}</div>
<div class="name">{{match.teams.optional.name | uppercase}}</div>
